<template>
  <div class="pdf-viewer-container">
    <pdf
      v-if="isAuthorized && pdfSource"
      :src="pdfSource"
      style="height: 100vh; width: 100vw; padding: 0"
    />
    <div v-else-if="!isAuthorized" class="access-denied">
      <p>Access Denied: You do not have permission to view this document.</p>
    </div>
    <div v-else class="loading">
      <p>Loading PDF...</p>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import Axios from "axios";
import MD5 from "crypto-js/md5";
import config from "@/config";

export default {
  name: "PdfViewer",
  components: { pdf }, // <-- регистрируем как 'pdf'
  data() {
    return {
      pdfSource: null,
      isAuthorized: false,
      secret: "YLDH92qhgg",
    };
  },
  beforeDestroy() {
    if (
      this.pdfSource &&
      typeof this.pdfSource === "string" &&
      this.pdfSource.indexOf("blob:") === 0
    ) {
      URL.revokeObjectURL(this.pdfSource);
    }
  },
  mounted() {
    this.validateAccess();
  },
  methods: {
    validateAccess() {
      const documentId = this.$route.params.cmrId;
      const providedLink = this.$route.query.link;
      const expectedHash = MD5(documentId + this.secret).toString();
      if (providedLink === expectedHash) {
        this.isAuthorized = true;
        this.fetchPdf(documentId);
      } else {
        this.isAuthorized = false;
      }
    },
    async fetchPdf(documentId) {
      const type = "1";
      const link = MD5(documentId + type + this.secret).toString();
      const url = `${
        config.apiBaseUrl
      }api/cmr/download-document?documentId=${encodeURIComponent(
        documentId
      )}&type=${type}&link=${link}`;
      const { data: blob } = await Axios.get(url, { responseType: "blob" });
      this.pdfSource = URL.createObjectURL(blob); // отдаём как URL
    },
  },
};
</script>

<style scoped>
.pdf-viewer-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.access-denied {
  text-align: center;
  font-size: 1.5em;
  padding-top: 20vh;
  color: red;
}

.loading {
  text-align: center;
  font-size: 1.5em;
  padding-top: 20vh;
}
</style>
